import React from 'react';
import successSvg from '../../assets/images/successSvg.svg';
import Modal from "react-bootstrap/Modal";

function SaveSuccessModel(props) {
    const { show, createMsg, setShow , SuccessDoneClick} = props
    const handleHide = SuccessDoneClick || (() => setShow(false));
    return (
        <Modal
            size='sm'
            show={show}
            centered
            className='saveSuccessModal'
            onHide={handleHide}
        >
            <Modal.Body>
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="success-image">
                            <img src={successSvg} alt="successSvg"></img>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="confirm-msg mt-2">
                            <h6>Success</h6>
                            <p>{createMsg?.message}</p>

                        </div>
                    </div> 
                </div>
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="done-btn">
                            <button type="button" className="btn" onClick={handleHide}>Done</button>
                        </div>
                    </div>
                </div>

            </Modal.Body>
        </Modal>
    )
}

export default SaveSuccessModel